import styled from "styled-components";

export const RemovedText = styled.span`
    text-decoration: line-through;
`;

export const AddedText = styled.span`
    background-color: lightgreen;
`;
